import React, { useState, useRef } from 'react';
import _map from 'lodash/map';
import {
  TemplateId,
  TemplateVersion,
  TemplateInfoContainer,
  Template,
  TemplateTooltipContainer,
  TooltipContainer,
} from 'styles/blocks/templateTooltip';

const TemplateInfo = ({ id, version, modifier }) => (
  <Template modifier={modifier}>
    <TemplateId>{id}:</TemplateId>
    <TemplateVersion>{version}</TemplateVersion>
  </Template>
);

export function Tooltip({ templates, conditionVersion, children }) {
  const [showTooltip, setShowToolTip] = useState(false);
  const [isBottomTooltip, setIsBottomTooltip] = useState(true);
  const ref = useRef(null);
  const handleMouseEnter = () => {
    if (ref.current !== null) {
      if ((ref.current.getBoundingClientRect().bottom + 140) >= (window.innerHeight)) {
        setIsBottomTooltip(false);
      }
    }
    setShowToolTip(true);
  };
  const handleMouseLeave = () => {
    setShowToolTip(false);
    setIsBottomTooltip(true);
  };
  return (
    <TooltipContainer onMouseLeave={handleMouseLeave} ref={ref}>
      <span onMouseOver={handleMouseEnter} onFocus={handleMouseEnter}>
        {children}
      </span>
      {showTooltip && (
        <TemplateTooltipContainer bottom={isBottomTooltip}>
          <TemplateInfo id="CONDITION" version={conditionVersion} modifier={['marginBottom', 'borderBottom']} />
          <TemplateInfoContainer>
            {_map(templates, template => {
              return <TemplateInfo key={`templateInfo-${template.referredId}`} id={template.referredId} version={template.version} />;
            })}
          </TemplateInfoContainer>
        </TemplateTooltipContainer>
      )}
    </TooltipContainer>
  );
}
